import { format, formatURL } from "../../common/utilities/format";
import { graphJSON, graphNoContent, graphResponse } from "./network";

interface IBadgerResponse {
  token: string;
}

const sharesApi = "{{vroomOrigin}}/{{apiVersion1}}/shares/u!{{redeemToken}}/driveitem?{{parameters}}";

export function requestRedeemToken(fetch: (url: string, init?: RequestInit) => Promise<Response>, redeemToken: string): Promise<void> {
  return graphResponse<void>(
    fetch(formatURL(sharesApi, { redeemToken, parameters: new URLSearchParams({ $select: "id,parentReference" }) }), {
      headers: { "Content-Type": "text/plain;charset=UTF-8", Prefer: "autoredeem" },
      method: "POST"
    }),
    graphJSON
  );
}

const refreshApi = "{{authOrigin}}/auth/refresh?{{parameters}}";

export function refreshToken(fetch: (url: string, init?: RequestInit) => Promise<Response>, scope: string, refresh_token: string): Promise<void> {
  return graphResponse(fetch(formatURL(refreshApi, { parameters: new URLSearchParams({ scope, refresh_token }) })), graphNoContent);
}

const badgerApi = "{{badgerApiOrigin}}/v1.0/token";

export function requestBadgerToken(fetch: (url: string, init?: RequestInit) => Promise<Response>): Promise<string> {
  return graphResponse<IBadgerResponse>(
    fetch(badgerApi, {
      body: JSON.stringify({ appId: "073204aa-c1e0-4e66-a200-e5815a0aa93d" }),
      headers: {
        "Content-Type": "application/json;odata=verbose",
        "Cache-Control": "private"
      },
      method: "POST"
    }),
    graphJSON
  ).then((response) => response.token);
}

const validatePasswordApiUnAuthUsers = "{{vroomOrigin}}/{{apiVersion1}}/shares/{{encodedShareUrl}}/root/action.validatePermission";
const validatePasswordApi = "{{vroomOrigin}}/{{apiVersion1}}/drive/items/{{photoId}}/action.validatePermission";

export function validatePassword(
  fetch: (url: string, init?: RequestInit) => Promise<Response>,
  photoId: string,
  password: string,
  authToken: string,
  userAuthenticated: boolean
): Promise<void> {
  let formattedApiUrl: string;

  if (userAuthenticated) {
    formattedApiUrl = formatURL(validatePasswordApi, { photoId });
  } else {
    const encodedShareUrl = `u!${window
      .btoa(formatURL("https://api.onedrive.com/redir?{{parameters}}", { parameters: new URLSearchParams({ resid: photoId }) }))
      .replace(/=/g, "")
      .replace(/[+]/g, "-")
      .replace(/\//g, "_")}`;

    formattedApiUrl = format(validatePasswordApiUnAuthUsers, { encodedShareUrl });
  }

  if (authToken && authToken.charAt(0) === "!") {
    authToken = authToken.slice(1);
  }

  return graphResponse(
    fetch(formattedApiUrl, {
      body: JSON.stringify({
        challengeToken: authToken,
        password: password
      }),
      headers: { "Content-Type": "application/json" },
      method: "POST"
    }),
    (response: Response) => {
      if (response.ok && (response.status === 204 || response.status === 200)) {
        return Promise.resolve();
      } else {
        return Promise.reject(response);
      }
    }
  );
}
